import videojs from 'video.js';
import VkAuthItem from './vk-auth-item';
import FacebookAuthItem from './facebook-auth-item';
import TwitterAuthItem from './twitter-auth-item';
import EmailAuthItem from './email-auth-item';

export default class AuthProvidersMenu extends videojs.EventTarget {
  constructor(player, providers, containerEl, menuEl) {
    super();
    this.player = player;
    this.providers = providers;
    this.containerEl = containerEl;
    this.menuEl = menuEl;
    this.itemsList = [];
    this._createItems();
  }

  _createItems() {
    const menu = this;

    if (this.providers.includes('vk')) {
      let vkAuthItem = new VkAuthItem(menu);
      this.itemsList.push(vkAuthItem);
    }
    if (this.providers.includes('facebook')) {
      let facebookAuthProvider = new FacebookAuthItem(menu);
      this.itemsList.push(facebookAuthProvider);
    }
    if (this.providers.includes('twitter')) {
      let twitterAuthProvider = new TwitterAuthItem(menu);
      this.itemsList.push(twitterAuthProvider);
    }
    if (this.providers.includes('email')) {
      let emailAuthProvider = new EmailAuthItem(menu);
      this.itemsList.push(emailAuthProvider);
    }
  }

  render() {
    this.itemsList.forEach((item) => {
      item.render();
      item.on('authProviderChoosed', event => this.trigger(event));
    });
  }

  hideMenu() {    
    this.menuEl.classList.add('vjs-hidden');
  }

  hide() {
    this.hidePopups();
    this.hideMenu();
  }

  hidePopups() {
    this.itemsList.forEach(item => {
      item.hidePopup && item.hidePopup();
    });
  }

  showMenu() {
    this.menuEl.classList.remove('vjs-hidden');
  }
}
